import { FormControl } from "components/molecules/FormControl";
import { NumberInput } from "components/atoms/NumberInput";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { setTotalShipmentValue } from "store/createShipmentSlice/index.slice";
import { useDispatch } from "react-redux";

export const TotalItemValue = ({}) => {
  const { totalShipmentValue } = useSelector((state: RootState) => {
    return state.createShipmentSlice;
  });

  const dispatch = useDispatch();

  return (
    <FormControl
      label="Set total shipment value"
      isRequired={false}
      testId={`1`}
    >
      <NumberInput
        value={totalShipmentValue}
        // onBlur={onTouchItemValue}
        onChange={(value) => {
          dispatch(setTotalShipmentValue(value));

          //   onTouchItemValue();
        }}
        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
          e.target.select();
        }}
      />
    </FormControl>
  );
};
